<template>
  <a-modal
    title="添加用户"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
    okText="确认">
   <a-transfer
      showSearch
      :data-source="mockData"
      :titles="['用户列表', '分配用户']"
      :listStyle="{
          width: '320px',
          height: '300px',
      }"
      :locale="{ itemUnit: '项', itemsUnit: '项', notFoundContent: '列表为空', searchPlaceholder: '请输入搜索内容' }"
      :target-keys="targetKeys"
      :selected-keys="selectedKeys"
      :render="item => `${item.title}(${item.orgName})`"
      @change="handleChange"
      @selectChange="handleSelectChange"
      @search="search"
    />
  </a-modal>
</template>

<script>
import { getUserPage } from '@/baseAPI/user'
import { roleAddUsers } from '@/baseAPI/role'
export default {
  name: 'AddUsersModal',
  data () {
    return {
      roleId: '',
      visible: false,
      confirmLoading: false,
      mockData: [],
      targetKeys: [],
      selectedKeys: []
    }
  },
  mounted: function () {
  },
  methods: {
    show (id) {
      this.roleId = id
      this.getUserPage()
      this.visible = true
    },
    getUserPage() {
      getUserPage({ size: 500, current: 1 }).then(res => {
        this.mockData = res.data.records.map(item => { return { key: item.userId, title: item.name, orgName: item.orgName } })
        this.targetKeys = res.data.records.filter(item=> item.sysRoleIds && item.sysRoleIds.includes(this.roleId)).map(item => item.userId)
      })
    },
    handleCancel () {
      this.visible = false
    },
    handleChange(nextTargetKeys) {
      this.targetKeys = nextTargetKeys;
    },
    handleSelectChange(sourceSelectedKeys, targetSelectedKeys) {
      this.selectedKeys = [...sourceSelectedKeys, ...targetSelectedKeys];
    },
    search (direction, value) {
      return this.mockData.filter(item => item.title.indexOf(value.trim()) > 0 || item.orgName.indexOf(value.trim()) > 0)
    },
    handleOk(){
      const _this = this
      this.$confirm({
        title: '确认操作',
        content: '是否添加用户?',
        okText: '确认',
        cancelText: '取消',
        onOk: function () {
          _this.confirmLoading = true
          roleAddUsers(_this.roleId, _this.targetKeys).then(res => {
            _this.$notification.success({
              message: '提示',
              description: res.message || '添加用户成功',
              duration: 3
            })
            _this.confirmLoading = false
            _this.$emit('ok')
            _this.visible = false
          }).catch(err => {
            _this.$notification.error({
              message: '错误',
              description: ((err.response || {}).data || {}).message || '添加用户失败',
              duration: 3
            })
            _this.confirmLoading = false
            _this.handleCancel()
          })
        }
      })
    }
  }
}
</script>
